import {
  CHECK_ONBOARDING_STATUS,
  CHECK_ONBOARDING_STATUS_SUCCESS,
  CHECK_ONBOARDING_STATUS_FAILURE,
  COMPLETE_ONBOARDING,
  COMPLETE_ONBOARDING_SUCCESS,
  COMPLETE_ONBOARDING_FAILURE,
  CLEAR_ONBOARDING_FLAGS,
  RESET_ONBOARDING_STATE,
  SET_POST_ONBOARDING_VISIBLE,
} from "../../modules/constants";
import { createNotification } from "../../modules/notificationManager";

// ------------------------------------
// Action handler methods
// ------------------------------------

export const handleCheckOnboardingStatus = (state, action) => {
  return {
    ...state,
    isLoading: true,
    error: null,
    errorMessage: "",
  };
};

export const handleCheckOnboardingStatusSuccess = (state, action) => {
  const { data } = action.payload;

  if (data.show_onboard) {
    return {
      ...state,
      isLoading: false,
      needsOnboarding: true,
      pendingInvitation: data.pending_invitation || null,
      pendingJoinRequest: data.pending_join_request || null,
      joinLink: data.invitation_link || null,
      attributionData: data.attribution_data || null,
      serverResponse: data,
      error: null,
      errorMessage: "",
    };
  } else {
    return {
      ...state,
      isLoading: false,
      needsOnboarding: false,
      pendingInvitation: null,
      pendingJoinRequest: null,
      joinLink: data.invitation_link || null,
      attributionData: null,
      serverResponse: null,
      error: null,
      errorMessage: "",
    };
  }
};

export const handleCheckOnboardingStatusFailure = (state, action) => {
  const {
    payload: { response },
  } = action;


  if (response === undefined) {
    createNotification("error", "No internet connection found", 2000);
    return {
      ...state,
      isLoading: false,
      error: "network_error",
      errorMessage: "No internet connection found",
    };
  } else {
    createNotification("error", "Failed to check onboarding status", 3000);
    return {
      ...state,
      isLoading: false,
      error: "api_error",
      errorMessage: "Failed to check onboarding status",
    };
  }
};

export const handleCompleteOnboarding = (state, action) => {
  return {
    ...state,
    isSubmitting: true,
    error: null,
    errorMessage: "",
  };
};

export const handleCompleteOnboardingSuccess = (state, action) => {
  createNotification("success", "Welcome to FieldServicely!", 3000);
  const { data } = action.payload;
  return {
    ...state,
    isSubmitting: false,
    needsOnboarding: false,
    pendingInvitation: null,
    attributionData: null,
    serverResponse: null,
    error: null,
    errorMessage: "",
    completedAt: Date.now(),
    joinLink: data?.invitation_link || null,
    userRole: data?.role || null,
    organizationId: data?.id || null,
  };
};

export const handleCompleteOnboardingFailure = (state, action) => {
  const {
    payload: { response },
  } = action;

  if (response === undefined) {
    createNotification("error", "No internet connection found", 2000);
  } else if (response.data && response.data.non_field_errors) {
    createNotification("error", response.data.non_field_errors[0], 3000);
  } else {
    createNotification("error", "Failed to complete onboarding", 3000);
  }

  return {
    ...state,
    isSubmitting: false,
    error: "submission_error",
    errorMessage: "Failed to complete onboarding",
  };
};

export const handleClearOnboardingFlags = (state, action) => {
  return {
    ...state,
    needsOnboarding: false,
    pendingInvitation: null,
    attributionData: null,
    serverResponse: null,
    error: null,
    errorMessage: "",
    completedAt: null, // Clear completedAt to prevent modal from reappearing
    joinLink: null,
    userRole: null,
    organizationId: null,
  };
};

export const handleResetOnboardingState = (state, action) => {
  return {
    ...initialState,
  };
};

export const handleSetPostOnboardingVisible = (state, action) => ({
  ...state,
  isPostOnboardingVisible: action.payload,
});

// Action Handlers
const ACTION_HANDLERS = {
  [CHECK_ONBOARDING_STATUS]: handleCheckOnboardingStatus,
  [CHECK_ONBOARDING_STATUS_SUCCESS]: handleCheckOnboardingStatusSuccess,
  [CHECK_ONBOARDING_STATUS_FAILURE]: handleCheckOnboardingStatusFailure,

  [COMPLETE_ONBOARDING]: handleCompleteOnboarding,
  [COMPLETE_ONBOARDING_SUCCESS]: handleCompleteOnboardingSuccess,
  [COMPLETE_ONBOARDING_FAILURE]: handleCompleteOnboardingFailure,

  [CLEAR_ONBOARDING_FLAGS]: handleClearOnboardingFlags,
  [RESET_ONBOARDING_STATE]: handleResetOnboardingState,
  [SET_POST_ONBOARDING_VISIBLE]: handleSetPostOnboardingVisible,
};

// default initial state
const initialState = {
  needsOnboarding: null,
  pendingInvitation: null,
  attributionData: null,
  serverResponse: null,
  isLoading: false,
  isSubmitting: false,
  error: null,
  errorMessage: "",
  completedAt: null,
  joinLink: null,
  userRole: null,
  organizationId: null,
  isPostOnboardingVisible: false,
};

export default function onboardingNewReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
